<template>
  <div class="edit-predicted-income-wo-actual-popup-flow">
    <edit-predicted-income-w-o-actual v-if="componentIndex === 0"
                                            :predicted-transaction="predictedTransaction"
                                            :close-action="close"
                                            :next-action="next" />

    <cancel-prediction-summary v-else
                                     :predicted-transaction="predictedTransaction"
                                     :close-action="close"
                                     :back-action="back" />
  </div>
</template>

<script>
import Segment from '../../../../../../../../../../../../Segment';
import EditPredictedIncomeWOActual from '../EditPredictedIncomeWOActual.vue';
import CancelPredictionSummary from '../CancelPredictionSummary.vue';

export default {
  name: 'EditPredictedIncomeWOActualFlow',
  components: {
    EditPredictedIncomeWOActual,
    CancelPredictionSummary,
  },
  props: {
    predictedTransaction: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      componentIndex: 0,
    };
  },
  methods: {
    close() {
      Segment.trackUserInteraction('EditPredictedIncomeWOActualFlow_Closed', {
        predictedTransaction: this.predictedTransaction,
      });
      this.$emit('close');
    },
    back() {
      this.componentIndex = 0;
    },
    next() {
      this.componentIndex = 1;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/current-month/components/cashflow-edit/edit-transaction/edit-predicted-transaction/flows/EditPredictedIncomeWOActualFlow.vue